import { HStack, Select as ChakraSelect } from "@chakra-ui/react";
import type { GuidedBudgetMode } from "./GuidedBudgetEditor";
import { guidedBudgetFieldBorder, guidedBudgetFieldShadow } from "./guidedBudgetEditorTokens";

type GuidedBudgetTypeSelectProps = {
  mode: GuidedBudgetMode;
  allowScheduled: boolean;
  disableBudgetTypeChange: boolean;
  onChangeBudgetType: (type: GuidedBudgetMode) => void;
};

export function GuidedBudgetTypeSelect({
  mode,
  allowScheduled,
  disableBudgetTypeChange,
  onChangeBudgetType,
}: GuidedBudgetTypeSelectProps) {
  return (
    <HStack
      flex={1}
      minW={{ base: "full", md: "200px" }}
      borderWidth="1px"
      borderColor={guidedBudgetFieldBorder}
      borderRadius="8px"
      bg="white"
      boxShadow={guidedBudgetFieldShadow}
      px="12px"
      py="10px"
      spacing={3}
      align="center"
      _focusWithin={{
        borderColor: "blue.500",
        boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)",
      }}
    >
      <ChakraSelect
        aria-label={
          disableBudgetTypeChange
            ? "Budget type (cannot be changed for campaigns linked to Meta)"
            : "Budget type"
        }
        value={mode}
        isDisabled={disableBudgetTypeChange}
        onChange={(e) => onChangeBudgetType(e.target.value as GuidedBudgetMode)}
        flex={1}
        minW={0}
        w="full"
        variant="unstyled"
        fontSize="md"
        lineHeight="23px"
        fontWeight="normal"
        color="#222222"
        letterSpacing="-0.48px"
        cursor={disableBudgetTypeChange ? "not-allowed" : "pointer"}
        _focusVisible={{ boxShadow: "none" }}
        sx={{
          appearance: "none",
          WebkitAppearance: "none",
          MozAppearance: "none",
          backgroundImage: "none",
          "&::-ms-expand": { display: "none" },
        }}
      >
        <option value="lifetime">Lifetime budget</option>
        <option value="daily">Daily budget</option>
        {allowScheduled ? <option value="scheduled">Scheduled budget</option> : null}
      </ChakraSelect>
    </HStack>
  );
}
